$(document).ready(function() {
  if(($("#no_variant").size()) > 0)
  {
    $(document).on('submit', '.product-single__form', function(){
      if(typeof($('.single-option-radio input:checked').val()) == "undefined" || $('.single-option-radio input:checked').val() == '')
      {
        if($(window).width() < 768){
            $('html, body').animate({ scrollTop: $('.error-msg').offset().top}, 1000);
        }
        $('.error-msg').show();
        return false;
      }else{
        $('.error-msg').hide();
      }
    });

     $(document).on('click', '.variant_permalink', function(e){
       e.preventDefault();
       //console.log("called");
      if(typeof($('.single-option-radio input:checked').val()) == "undefined" || $('.single-option-radio input:checked').val() == ''){
        if($(window).width() < 768){
            $('html, body').animate({ scrollTop: $('.error-msg').offset().top}, 1000);
        }
        $('.error-msg').show();
        return false;
      }else{
        $('.error-msg').hide();
        window.location.href = $(this).attr("href");
      }
    });
  }
});